import { useState } from "react";
import PropTypes from "prop-types";
import { Input } from "antd";
import { EditOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";

const EditableSeriesItem = ({ series, onSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(series.name);

  const handleStartEdit = (e) => {
    e.stopPropagation();
    setIsEditing(true);
    setEditValue(series.name);
  };

  const handleSave = (e) => {
    e.stopPropagation();
    if (editValue.trim() && editValue !== series.name) {
      onSave(editValue.trim());
    }
    setIsEditing(false);
  };

  const handleCancel = (e) => {
    e.stopPropagation();
    setEditValue(series.name);
    setIsEditing(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSave(e);
    } else if (e.key === "Escape") {
      handleCancel(e);
    }
  };

  return (
    <div className="series-item">
      {series.image && (
        <img src={series.image} alt={series.name} className="series-image" />
      )}
      {isEditing ? (
        <>
          <Input
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
            onKeyDown={handleKeyDown}
            autoFocus
            style={{ flex: 1, marginRight: 8 }}
          />
          <CheckOutlined
            onClick={handleSave}
            style={{ color: "#52c41a", marginRight: 8, fontSize: 14, cursor: "pointer" }}
          />
          <CloseOutlined
            onClick={handleCancel}
            style={{ color: "#ff4d4f", fontSize: 14, cursor: "pointer" }}
          />
        </>
      ) : (
        <>
          <span className="series-name">{series.name}</span>
          <EditOutlined
            onClick={handleStartEdit}
            style={{ color: "#1890ff", fontSize: 14, cursor: "pointer" }}
          />
        </>
      )}
    </div>
  );
};

EditableSeriesItem.propTypes = {
  series: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    image: PropTypes.string,
    images: PropTypes.array,
  }).isRequired,
  onSave: PropTypes.func.isRequired,
};

export default EditableSeriesItem;
